// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// eslint-disable-next-line
import pckg from '../../../../package.json';

const baseUrl = process.env.BASE_API_URL || 'https://api.test.app.clos.vc';

export const environment = {
  production: false,
  // On-demand creation and invite issuance are enabled only for the test rollout.
  roomInvitesOnDemand: baseUrl === 'https://api.test.app.clos.vc',
  firstPartyInviteOrigin: 'https://link.test.clos.vc',
  webAppOrigin: 'https://test.app.clos.vc',
  roomCreationOperationIds: baseUrl === 'https://api.test.app.clos.vc',
  api: {
    baseUrl,
    storeBaseUrl: `${baseUrl}/v1/image/upload`,
    ver: '2.4.8',
    appName: 'clos',
    platform: 'web',
  },
  firebase: {
    apiKey: 'AIzaSyCiEr6QoFbgu9ve5gXBXg7FJFABr-juLJ0',
    authDomain: 'clos-34cea.firebaseapp.com',
    databaseURL: 'https://clos-34cea.firebaseio.com',
    projectId: 'clos-34cea',
    storageBucket: 'clos-34cea.appspot.com',
    messagingSenderId: '783858920746',
    appId: '1:783858920746:web:0353732fda7a2c4c05c253',
    measurementId: 'G-22RWH94NRL',
  },
  branchIo: {
    apiKey: 'key_live_ahUU1Rguue3q220r91eWngpdvqpDCqiw',
  },
  amazon: {
    url: 'https://s3.closapp.space/dev/upload',
  },
  revenuecat: {
    // Paddle sandbox public key. Previous Web Billing key: rcb_sb_uAFsUZeKtKIDgsxpKqXZzbuCw
    apiKey: 'pdl_NWuMfspNyVBwMXnHbdsWIlVvsUtp',
    // Read this offering explicitly instead of the project-global `current`
    // offering (which is shared with the iOS/Android apps).
    offeringId: 'paddle_default',
  },
  subscriptionsEnabled: true,
  version: pckg.version,
  indexDb: {
    collections: {
      assets: 'assets',
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
